<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      
      <div class="formTableItem">
        <Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <p slot="ordersGoodsList" slot-scope="{ row, index }">
        共{{ row.ordersGoodsList.length }}条数据
      </p>
      <p slot="ordersChargesList" slot-scope="{ row, index }">
        共{{ row.ordersChargesList.length }}条数据
      </p>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增订单基本信息' : '编辑订单基本信息'"
      width="1000"
      ref="formModel"
      fenlei
      height="500"
    >
      <tableForm
        slot="ordersGoodsList"
        ref="ordersGoodsList"
        :forms="ordersGoodsListForm"
        :item1="ordersGoodsListItem"
        v-model="item.ordersGoodsList"
        height="400"
      >
      </tableForm>
      <tableForm
        slot="ordersChargesList"
        ref="ordersChargesList"
        :forms="ordersChargesListForms"
        :item1="ordersChargesListItem"
        v-model="item.ordersChargesList"
        height="400"
      >
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "订单编号",
          minWidth: 130,
          key: "no",
          sort: 0,
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
          sort: 50,
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        //no: "",
        customer: "",
        customerNo: "",
        contractNo: "",
        contact: "",
        tel: "",
        carType: "3T吨车",
        ordersGoodsList: [
          //订单货物列表
        ],
        ordersChargesList: [
          //订单收费项目列表
        ],
        addressS: "",
        xs: 0,
        ys: 0,
        addressD: "",
        xd: 0,
        yd: 0,
        bpMode: false, //0包车 1拼车
        payMode: "现金", //转账，支票，现金
        clearanceMode: "电子报关",
        transportMode: "陆运",
        deliveryMode: "派送",
        recevieModel: "上门取货",
        isTransfers: false, //货物是否中转 0--否  1--是
        isTax: false, //是否含税 0--否  1--是
        taxRate: 0,
        exchangeRate: 0,
        currency: "人民币",
        sendDate: "",
        salemanId: "",
        saleman: "",
        remark: "",
        extendFields: "",
        filesPath: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "客户名称",
          key: "customer",
          type: "Input",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "货币类型",
          key: "currency",
          type: "Select",
          selectItems: ["人民币", "港元", "美元", "欧元", "日元", "韩元"],
          required: true,
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "交货方式",
          key: "deliveryMode",
          type: "Select",
          selectItems: ["派送", "提货", "自提", "自送", "存仓"],
          required: true,
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "收货方式",
          key: "recevieModel",
          type: "Select",
          selectItems: ["上门取货", "自提", "自送"],
          required: true,
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "运输方式",
          key: "transportMode",
          type: "Select",
          selectItems: ["陆运", "空运", "水运"],
          required: true,
          filterable: true,
          allowCreate: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "支付方式",
          key: "payMode",
          type: "Select",
          selectItems: ["转账", "支票", "现金"],
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "报关方式",
          key: "clearanceMode",
          type: "Select",
          selectItems: ["电子报关", "客人自提"],
          required: true,
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "是否拼车",
          key: "bpMode",
          key2: "bpMode2",
          type: "bool",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "货物是否中转",
          key: "isTransfers",
          key2: "isTransfers2",
          type: "bool",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "是否含税",
          key: "isTax",
          key2: "isTax2",
          type: "bool",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "税率",
          key: "taxRate",
          type: "InputNumber",
          required: true,
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "发货日期",
          key: "sendDate",
          key2: "sendDate2",
          type: "lyyymmdd",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "客户单号",
          key: "customerNo",
          type: "Input",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "业务员",
          ke4: "salemanId",
          key1: "saleman",
          type: "selectUser",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "合同编号",
          key: "contractNo",
          type: "Input",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "联系人",
          key: "contact",
          type: "Input",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "联系方式",
          key: "tel",
          type: "Input",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "数据",
          key: "carType",
          type: "Select",
          selectItems: [
            "3T吨车",
            "5T吨车",
            "8T吨车",
            "10T吨车",
            "12T吨车",
            "16T吨车",
            "20GP柜车",
            "40GP柜车",
            "45GP柜车",
            "20HQ柜车",
            "40HQ柜车",
            "45HQ柜车",
          ],
          required: true,
          span: 8,
          fenlei: "基本信息",
          filterable: true,
          allowCreate: true,
        },
        {
          title: "提货地点",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          type: "selectAddMap",
          span: 8,
          width: 300,
          fenlei: "基本信息",
        },
        {
          title: "送货地点",
          key: "addressD",
          keyX: "xd",
          keyY: "yd",
          type: "selectAddMap",
          span: 8,
          width: 300,
          fenlei: "基本信息",
        },
        {
          title: "电话",
          key: "tel",
          type: "Input",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 8,
          fenlei: "基本信息",
        },
        {
          title: "订单货物项目",
          key: "ordersGoodsList",
          slot: "ordersGoodsList",
          slotForm: "ordersGoodsList",
          span: 24,
          required: true,
          fenlei: "货物项目",
        },
        {
          title: "订单收费项目",
          key: "ordersChargesList",
          slot: "ordersChargesList",
          slotForm: "ordersChargesList",
          span: 24,
          required: true,
          fenlei: "收费项目",
        },
      ],
      ordersGoodsListForm: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "条码",
          key: "barCode",
          type: "Input",
          required: true,
        },
        {
          title: "型号",
          key: "model",
          type: "Input",
        },
        {
          title: "体积",
          key: "volume",
          type: "InputNumber",
          required: true,
        },
        {
          title: "件数",
          key: "amount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "重量",
          key: "weight",
          type: "InputNumber",
          required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      ordersGoodsListItem: {
        //id: 0,
        name: "",
        barCode: "", //条码/编码
        volume: 0, //体积(立方)
        model: "", //型号
        amount: 0, //件数
        weight: 0,
        imgPath: "",
        remark: "",
        //keyWork: "",
        //idList: [],
      },
      ordersChargesListForms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "标签",
          key: "lable",
          type: "Input",
          required: true,
        },
        {
          title: "应收金额",
          key: "receiveAmount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "应付金额",
          key: "payAmount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      ordersChargesListItem: {
        //id: 0,
        name: "111",
        lable: "始发地费用", //	标签(始发地费用，目的地费用)
        receiveAmount: 0, //应收金额
        payAmount: 0, //应付金额
        remark: "",
        //keyWork: "",
        //idList: [],
      },
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          data[i].sendDate2 = this.utils.time(data[i].sendDate, "yymmdd");
          data[i].isTax2 = this.$t("bool." + data[i].isTax);
          data[i].isTransfers2 = this.$t("bool." + data[i].isTransfers);
          data[i].bpMode2 = this.$t("bool." + data[i].bpMode);
        }
        this.tableData = data;
      });
    },

    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      var b = this.$refs.ordersGoodsList.yanzheng("货物项目");
      var c = this.$refs.ordersChargesList.yanzheng("收费项目");
      if (!(b && c)) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/orders/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
      this.getTempList();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },

    getTempList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "ordersChargesList") {
            //alert(this.forms[j].key)
            this.item[this.forms[i].key] = data;
          }
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 200,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.getList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/dingdan/dingdanxinxi.vue